import blog1 from "../assets/png/blog1.png";
import blog2 from "../assets/png/blog2.png";
import blog3 from "../assets/png/blog3.jpg";

export const blogData = [
  // {
  //   id: 1,
  //   title: "A Guide to Overcoming Personal, Interpersonal, and Societal Challenges",
  //   description:
  //     "In this blog I wrote about how to overcome our different type of challenges",
  //   date: "Jan, 2024",
  //   image: "",
  //   url: "https://thoughts-venky.blogspot.com/2024/01/tips-to-overcome-unhappiness.html",
  // },
  {
    id: 1,
    title: "Empowering Nonprofits with Tech: The Force for Good Journey at Swadha Foundation",
    description:
      "In this blog I wrote about how to I had my first project journey in Swadha Foundation",
    date: "Nov, 2023",
    image: blog3,
    url: "https://thoughts-venky.blogspot.com/2023/11/project-for-good.html",
  },
  {
    id: 2,
    title: "Is it ocean or hell",
    description:
      "In this blog I wrote about how the aqua animals and birds was affected by the pollution",
    date: "Jun, 2022",
    image: blog1,
    url: "https://thoughts-venky.blogspot.com/2022/06/is-it-ocean-or-hell.html",
  },
  {
    id: 3,
    title: "Masai Journey",
    description:
      "In this blog I wrote how I had journey throught Masai school",
    date: "5, 2022",
    image: blog2,
    url: "https://thoughts-venky.blogspot.com/2022/01/masai-experience.html",
  },
];
